export default __webpack_public_path__ + "static/setup-config-import-custom-field-aec3aec68c4548c472bc28413d801a5b.mp4";